import React from 'react';

const TrainingDetailsStep = ({ register, errors, watch }) => {
    const selectedSkill = watch('skillOfInterest');

    const skills = [
        {
            value: 'Baking',
            icon: 'fas fa-birthday-cake',
            description: 'Learn professional baking techniques and cake decoration'
        },
        {
            value: 'Cryptocurrency',
            icon: 'fas fa-coins',
            description: 'Understanding blockchain technology and crypto trading'
        },
        {
            value: 'Wig Revamp',
            icon: 'fas fa-user-tie',
            description: 'Wig customization, styling and maintenance'
        },
        {
            value: 'Forex',
            icon: 'fas fa-chart-line',
            description: 'Foreign exchange trading and market analysis'
        },
        {
            value: 'Social Media Marketing',
            icon: 'fas fa-hashtag',
            description: 'Strategies for growing brands on social platforms'
        },
        {
            value: 'Affiliate Marketing',
            icon: 'fas fa-link',
            description: 'Earning commissions by promoting products'
        },
        {
            value: 'Make-Up',
            icon: 'fas fa-eye',
            description: 'Professional makeup application techniques'
        },
        {
            value: 'Video Editing & Content Creation',
            icon: 'fas fa-video',
            description: 'Editing software and content production skills'
        },
        {
            value: 'Fashion Design/Tailoring',
            icon: 'fas fa-tshirt',
            description: 'Clothing design, pattern making and sewing'
        },
        {
            value: 'Graphics Design (Photoshop)',
            icon: 'fas fa-paint-brush',
            description: 'Digital design using Adobe Photoshop or similar tools'
        },
        {
            value: 'Arts & Crafts',
            icon: 'fas fa-palette',
            description: 'Creative handmade art projects'
        },
        {
            value: 'Data Science (Excel/Google Sheet)',
            icon: 'fas fa-table',
            description: 'Data analysis using spreadsheets'
        },
        {
            value: 'Shoe Making',
            icon: 'fas fa-shoe-prints',
            description: 'Footwear design and production'
        },
        {
            value: 'Coding & Web Design',
            icon: 'fas fa-code',
            description: 'Website development and programming'
        },
        {
            value: 'Visual Assistant',
            icon: 'fas fa-eye',
            description: 'Visual presentation and design assistance'
        },
        {
            value: 'Smart Office Assistant',
            icon: 'fas fa-briefcase',
            description: 'Office productivity and administrative skills'
        },
        {
            value: 'Photography & Retouching',
            icon: 'fas fa-camera',
            description: 'Photography techniques and photo editing'
        },
        {
            value: 'Public Speaking',
            icon: 'fas fa-microphone',
            description: 'Effective communication and presentation skills'
        },
        {
            value: 'Event Decoration',
            icon: 'fas fa-glass-cheers',
            description: 'Designing beautiful event spaces'
        },
        {
            value: 'Bead-Making & Crocheting',
            icon: 'fas fa-ring',
            description: 'Handmade jewelry and textile crafts'
        },
        {
            value: 'Cocktailing',
            icon: 'fas fa-cocktail',
            description: 'Mixology and beverage preparation'
        },
        {
            value: 'Project Management',
            icon: 'fas fa-tasks',
            description: 'Planning, organizing and managing projects'
        }
    ];

    const hearAboutOptions = [
        'Social Media',
        'Church Announcement',
        'Friend/Referral',
        'Flyer',
        'Others'
    ];

    return (
        <div>
            <h4 className="mb-4">
                <i className="fas fa-graduation-cap me-2 text-primary"></i>
                Training Details
            </h4>

            {/* Skill Selection */}
            <div className="mb-4">
                <label className="form-label">Select Your Skill of Interest (Choose only one) *</label>
                <div className="row">
                    {skills.map((skill, index) => (
                        <div key={skill.value} className="col-md-6 mb-3">
                            <div className={`skill-card ${selectedSkill === skill.value ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    className="form-check-input me-2"
                                    value={skill.value}
                                    {...register('skillOfInterest')}
                                    id={`skill-${index}`}
                                />
                                <label htmlFor={`skill-${index}`} className="form-check-label w-100 cursor-pointer">
                                    <div className="d-flex align-items-start">
                                        <i className={`${skill.icon} text-primary me-3 mt-1`}></i>
                                        <div>
                                            <h6 className="mb-1">{skill.value}</h6>
                                            <small className="text-muted">{skill.description}</small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
                {errors.skillOfInterest && (
                    <div className="text-danger small">{errors.skillOfInterest.message}</div>
                )}
            </div>

            {/* Experience and Availability */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label className="form-label">Do you have prior experience in the selected skill? *</label>
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={true}
                            {...register('hasPriorExperience')}
                            id="experienceYes"
                        />
                        <label className="form-check-label" htmlFor="experienceYes">
                            <i className="fas fa-check-circle text-success me-1"></i>
                            Yes, I have experience
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={false}
                            {...register('hasPriorExperience')}
                            id="experienceNo"
                        />
                        <label className="form-check-label" htmlFor="experienceNo">
                            <i className="fas fa-times-circle text-warning me-1"></i>
                            No, I'm a beginner
                        </label>
                    </div>
                    {errors.hasPriorExperience && (
                        <div className="text-danger small mt-1">{errors.hasPriorExperience.message}</div>
                    )}
                </div>

                <div className="col-md-6">
                    <label className="form-label">Are you available for the entire training duration? *</label>
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={true}
                            {...register('availableForFullDuration')}
                            id="availableYes"
                        />
                        <label className="form-check-label" htmlFor="availableYes">
                            <i className="fas fa-check-circle text-success me-1"></i>
                            Yes, fully available
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            value={false}
                            {...register('availableForFullDuration')}
                            id="availableNo"
                        />
                        <label className="form-check-label" htmlFor="availableNo">
                            <i className="fas fa-times-circle text-danger me-1"></i>
                            No, limited availability
                        </label>
                    </div>
                    {errors.availableForFullDuration && (
                        <div className="text-danger small mt-1">{errors.availableForFullDuration.message}</div>
                    )}
                </div>
            </div>

            {/* How did you hear about us */}
            <div className="mb-3">
                <label className="form-label">How did you hear about this training? *</label>
                <select
                    className={`form-select ${errors.hearAboutTraining ? 'is-invalid' : ''}`}
                    {...register('hearAboutTraining')}
                >
                    <option value="">Select an option...</option>
                    {hearAboutOptions.map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
                {errors.hearAboutTraining && (
                    <div className="invalid-feedback">{errors.hearAboutTraining.message}</div>
                )}
            </div>

            {/* Training Information */}
            <div className="alert alert-info">
                <h6><i className="fas fa-info-circle me-2"></i>Training Information</h6>
                <ul className="mb-0">
                    <li>Training duration: 4 weeks</li>
                    <li>Mode: Hybrid (Physical sessions in church)</li>
                    <li>Time: Sundays 12 PM - 2:30 PM</li>
                    <li>Location: Dominion City PH, Port Harcourt</li>
                    {/*<li>Certificate: Industry-recognized certification upon completion</li>*/}
                </ul>
            </div>
        </div>
    );
};

export default TrainingDetailsStep;